import Vue from "vue";
import tblMain from "@/assets/mmQR/tblMMQRMain.json";
export default class MMQR {
  
  // MMQR 검증
  isMMQR = false;
     
  getIsMMQR(){
    return this.isMMQR;
  }

  QRtoValue(qrString) {
    return parseTLVWithSchema(qrString, tblMain, 0);
  }
  // { key : 원하는 값을 나타내는 이름, id: 00, 01 같은 값, len: 길이, lang: 영어 or mmr 값}
  getMMQRHashMap(items) {
    var mmQRHashMap = {};
    for(var key in items) {   
      const item = items[key];

      if(item.children && item.children.length > 0) {
        const subItem = item.children;

        for(var elem in item.children) {    
          // MMQR 검증
          if(subItem[elem].key == "Guid" && subItem[elem].value == Vue.prototype.$config.MMQR_GUID){
            this.isMMQR = true;
          }
          mmQRHashMap[subItem[elem].key] = subItem[elem].value;

          console.log("subsubItem : " , subItem[elem], "  subItem[elem].value :    " + subItem[elem].value);
        }
      } else {
        mmQRHashMap[items[key].key] = items[key].value;
      }
    }
    console.log(`MMQR HASHMAP: ${JSON.stringify(mmQRHashMap)}`);
    return (this.getIsMMQR()) ? mmQRHashMap : "";
  }
}


function parseInnerTLV64(v64, schemaSub) {
  if(!v64 || v64.length < 4) return [];
  const out = [];
  let i = 0;

  // 내부 스키마 인덱스
  const innerIdToKey = schemaSub ? buildIdIndex(schemaSub) : null;
  while(i + 4 <= v64.length) {
    const id = v64.slice(i, i + 2);
    const lenStr = v64.slice(i + 2, i + 4);

    if(!/^\d{2}$/.test(id) || !/^\d{2}$/.test(lenStr)) break;

    i += 4; // 다음 위치로 이동(아이디, 길이 뽑았음)
    const declared = parseInt(lenStr, 10);
    const start = i;

    // 내부 Key 결정
    const key = innerIdToKey?.[id] ?? `Inner_${id}`
    // 0002MY
    if(id === "00") {
      const raw = v64.slice(start, start + declared);
      const trimmed = raw.replace(/ /g, "");
      out.push({
        key,
        id,
        len: declared,
        lang: detectEnglishByUniCode(trimmed),
        value: trimmed,
        raw
      });
      i = start + declared;
      continue;
    }


    if(id === "01") {
      const cut = readUntilNextInnerTag(v64, start, "02");
      const raw = cut.value;
      const trimmed = raw.replace(/ /g, "");

      out.push({
        key, 
        id, 
        len: declared,
        lang: detectEnglishByUniCode(trimmed),
        value: trimmed,
        raw
      });

      i = cut.end;
      continue;
    }

    if(id === "02") {
      const cut = readUntilNextAnyInnerTag(v64, start);
      const raw = cut.value;
      const trimmed = raw.replace(/ /g, "");

      out.push({
        key,
        id,
        len: declared,
        lang: detectEnglishByUniCode(trimmed),
        value: trimmed,
        raw
      });

      i = cut.end;
      continue;
    }

    const raw = v64.slice(start, start + declared);
    const trimmed = raw.replace(/ /g, "");
    out.push( {
      key,
      id,
      len: declared,
      lang: detectEnglishByUniCode(trimmed),
      value: trimmed,
      raw
    });
    i = start + declared;
   }

   return out;
}
/**
 * start부터 다음 inner Tag 패턴("02" + 2자리 Len) 나올 떄까지 Value로
 */
function readUntilNextInnerTag(input, start, nextTag) {
  const re = new RegExp(`${nextTag}\\d{2}`, "g");
  re.lastIndex = start;
  const m = re.exec(input);
  if(!m) return { value : input.slice(start), end: input.length};
  return { value: input.slice(start, m.index), end: m.index };
}

function readUntilNextAnyInnerTag(input, start) {
  const re = /(\d{2})(\d{2})/g;
  for(re.lastIndex = start + 1 ; ;){
    const m = re.exec(input);
    if(!m) return { value: input.slice(start), end: input.length }

    const idx = m.index;
    return { value: input.slice(start, idx), end: idx };
  }
}

function parseTLVWithSchema(input, schema, recursion = 0) {
  if(recursion > 2) return [];
  //let i = 0;
  const items = [];
  // 스키마: { key: { ID: "~~", subInfo: { key: value }}}
  const idToKey = buildIdIndex(schema);
  /***
   * 아이디 값이 64일때 템플릿으로 미얀마어가 나오는 이슈가 발생 
   * 미얀마어는 유니코드로 체크되기 때문에 보이는 것과 또 다르게 글자수가 체크되어
   * QR스펙과는 무관하게 흘러감 
   * 따라서 조치 필요
   */

  let chars = Array.from(input);
  let cursor = 0;
  console.log(`chars: ${chars}`);
  while(cursor < chars.length){
    var id = chars.slice(cursor, cursor + 2).join("");
    console.log(`id: ${id}`);
    var lenText = chars.slice(cursor + 2, cursor + 4).join("");
    var len = parseInt(lenText, 10);
    console.log(`len: ${len}`);
    var valueStart = cursor + 4;
    var valueEnd = valueStart + len;
    var value2 = chars.slice(valueStart, valueEnd).join("");
    console.log(`valueStart:${valueStart}, valueEnd: ${valueEnd}, value: ${value2}`);
    var key = idToKey[id] ?? `unknown_${id}`;

    if(id === "64") {
      const node = { key, id, len: len, lang: "mmr", value: value2, raw: value2 };
      node.children = parseInnerTLV64(value2, schema[key]?.subInfo);
      items.push(node);

    }
 
      const node = { key, id, len: len, lang: "mmr", value: value2, raw: value2 };
      const subSchema = schema[key]?.subInfo;
      const hasSubSchema = subSchema && Object.keys(subSchema).length > 0;

      cursor = valueEnd;
      if(hasSubSchema) {
        node.children = parseTLVWithSchema(value2, subSchema, recursion + 1);
      }
      items.push(node);
  }

  return items;
}

// 메인 테이블에서 만든 키가 맞다면 id값에 키를 넣어주기
function buildIdIndex(schema) {
  const map = Object.create(null);
  for(const key of Object.keys(schema)) {
    const id = schema[key]?.ID;
    if(typeof id === "string" && /^\d{2}$/.test(id)) {
      map[id] = key;
    }
  }
  return map;
}

// 언어 유니코드 테이블에서 특정 코드 범위 체크
function detectEnglishByUniCode(text){
   if(!text) return "unknown";

  const ranges = {
      english: /^[\x20-\x7E]+$/,
  };

  if (ranges.english.test(text)) return "eng";
  // 미얀마 언어에 대해서만 true를 주어 공백은 카운트에서 스킵되도록 조치
  return "mmr";
}
